import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ListInfo } from "../../../datastore/entities/listinfo.model";
import { PAGINATION_SELECTOR } from "../../../crossconcern/utilities/properties/selector.property";

@Component({
    selector: PAGINATION_SELECTOR,
    templateUrl: "./pagination.component.html"
})
export class PaginationComponent {

    @Input() public listInfo: ListInfo;
    @Output() public onPageChanged: EventEmitter<number> = new EventEmitter();

    private currentPage: number;

    constructor() {
        this.currentPage = 0;
    }

    public onPageClick(num: number) {
        this.currentPage = num;
        this.onPageChanged.emit(this.currentPage);
    }

    public onPageChange(forward: boolean) {
        this.currentPage = (forward) ? this.listInfo.number + 1 : this.listInfo.number - 1;
        this.onPageChanged.emit(this.currentPage);
    }
}
